import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox, CircularProgress } from '@mui/material';
import styled, { inputImages, inputNumbers, inputStyles } from '../../Utils/inputChanges';
import TitleBar from '../TitleBar';
import { Items } from '../TitleList';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { createItemEntry, fetchItemData, insertItemMaterial } from '../../Store/PHPSlice/Item';
import { selectBrandlist, selectItemAvg, selectItems } from '../Selectors/Master/ItemSelectors';
import { fetchBrandData } from '../../Store/PHPSlice/Rack';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchMaterialData } from '../../Store/PHPSlice/Material';
import { selectMaterials } from '../Selectors/Master/OutwardSelectors';
import RadioComponent from '../FieldsComponents/RadioComponent';
import { Preview } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';




const ItemMaterial2 = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        item: '',
        brand: '',
        matId: '',
        sizewise: '0',
        matNm: '',
        departId: '',
        userId: userdata?.ID
    });

    const [openDropdowns, setOpenDropdowns] = useState({});
    const [loading, setLoading] = useState(false);
    const actionMap = {
        item: fetchItemData,
        brand: fetchBrandData,
        matId: fetchMaterialData
        // Add more mappings if needed
    };

    const [material, setMaterial] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [errors, setErrors] = useState({});
    const [sizeWise, setSizeWise] = useState([]);
    const [viewData, setViewData] = useState([]);


    const dispatch = useDispatch();

    const itemlist = useSelector(selectItems);
    const brandlist = useSelector(selectBrandlist);
    const materiallist = useSelector(selectMaterials);
    const departlist = useSelector(selectDaparement);



    useEffect(() => {
        dispatch(fetchItemData());
        dispatch(fetchBrandData());
        dispatch(fetchMaterialData());
        dispatch(fetchDepartmentData());

        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };


    const isDesktop = useMediaQuery('(min-width:768px)');

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };


    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };


    const handleNavigateItem = () => {
        window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleNavigateBrand = () => {
        window.open(`/new-brand-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownlistfirst = [
        {
            label: 'Item',
            id: 'item',
            options: itemlist?.data || [],
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateItem(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('item'),
            handleDropdownClose: () => handleDropdownClose('item'),
        },
        {
            label: 'Brand',
            id: 'brand',
            options: brandlist?.data || [],
            value: formData.brand,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'brand', value: newValue ? newValue.ID : '' } }, 'brand'),
            getOptionLabel: (option) => option.brandNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateBrand(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('brand'),
            handleDropdownClose: () => handleDropdownClose('brand'),
        },
        //  {
        //     label: 'Department',
        //     id: 'departId',
        //     options: departlist?.data || [],
        //     value: formData.departId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'departId', value: newValue ? newValue.ID : '' } }, 'departId'),
        //     getOptionLabel: (option) => option.departNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     errors: errors.departId
        // },
        {
            label: 'Material',
            id: 'matId',
            options: materiallist?.data || [],
            value: formData.matId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'matId', value: newValue ? newValue.ID : '' } }, 'matId'),
            getOptionLabel: (option) => `${option.materialNm} - ${option.size}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            // handleAddNew: () => handleNavigateBrand(),
            // btnlabel: 'New',
            // handleDropdownOpen: () => handleDropdownOpen('matId'),
            // handleDropdownClose: () => handleDropdownClose('matId'),
        }
    ];


    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

        if (value === "1" && formData.item !== "" && formData.matId !== "") {
            const selectmatNm = materiallist?.data?.find((item) => item.ID === formData.matId);
            const selectSize = itemlist?.data?.find(
                item => item.ID === formData.item
            )?.size;

            const sizeArray = typeof selectSize === 'string'
                ? selectSize.split(',')
                : [];

            const objArray = sizeArray.map(size => ({
                size: size.trim(),
                matsize: '',
                qty: ''
            }));
            // console.log(selectmatNm.materialNm)

            const matnm = `${selectmatNm?.materialNm}-${selectmatNm?.size}`
            setSizeWise(objArray);
            setFormData(prev => ({
                ...prev,
                matNm: matnm
            }));

        } else {
            setSizeWise([]);
        }
    };

    const sizewiseoptions = [
        { label: 'Yes', value: "1" },
        { label: 'No', value: "0" }
    ];


    // console.log( brandlist?.data);
    const handleLumpColor = (index, value, name) => {
        const updatematerial = [...material];
        updatematerial[index][name] = value;
        setMaterial(updatematerial);
    };


    // const handleAddlump = () => {
    //     const selectMaterialObj = materiallist?.data?.find(item => item.ID === formData.matId);

    //     const matNm = selectMaterialObj ? `${selectMaterialObj?.materialNm} - ${selectMaterialObj?.size}` : '0';
    //    const deptNm = selectMaterialObj?.deptNm || '';

    //     const materialdata = {
    //         ID: 0,
    //         matId: formData.matId,
    //         materialNm: matNm,
    //         departNm:deptNm,
    //         qty: '0',
    //         sizewise: sizeWise,
    //         selected: false
    //     };
    //     setMaterial((prevRows) => [...prevRows, materialdata]);
    //     setSizeWise([]);
    //     setFormData(prev => ({
    //         ...prev,
    //         sizewise: '0',
    //         matId: '',
    //         matNm: '',
    //     }))
    // };

    const handleAddlump = () => {
        const selectMaterialObj = materiallist?.data?.find(
            item => item.ID === formData.matId
        );
        // console.log(selectMaterialObj);

        const matNm = selectMaterialObj
            ? `${selectMaterialObj.materialNm} - ${selectMaterialObj.size}`
            : '';

        const deptNm = selectMaterialObj?.deptNm || '';

        const materialdata = {
            ID: 0,
            matId: formData.matId,
            materialNm: matNm,
            deptNm: deptNm,
            qty: '0',
            sizewise: sizeWise,
            selected: false
        };

        setMaterial(prev => [...prev, materialdata]);
        setSizeWise([]);
        setFormData(prev => ({
            ...prev,
            sizewise: '0',
            matId: '',
            matNm: '',
        }));
    };

    const handleLumpSelection = (index) => {
        const newRows = [...material];
        newRows[index].selected = !newRows[index].selected;
        setMaterial(newRows);
    };

    const handleRemoveLumps = () => {
        const filteredRows = material.filter((row) => !row.selected);
        setMaterial(filteredRows);

        // const totmtr = filteredRows.reduce((acc, mtr) => acc + parseFloat(mtr.mtr), 0);
        // setLumpTotMtr(totmtr);
    };

    function postObj(formData, material) {
        const data = {
            itemId: formData.item,
            brandId: formData.brand,
            userId: formData.userId,
            material: material,
            departId: formData.departId,
            delMaterial: []
        };
        return data;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            const postdata = postObj(formData, material);
            // console.log(postdata);
            const result = await dispatch(insertItemMaterial(postdata)).unwrap();
            console.log('POST request successful!', result);
            // toast.success("Item Added");
            alert("Item Material Added");
            window.location.reload();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }
    };


    const handleSizeWiseChange = (index, field, value) => {
        setSizeWise(prev =>
            prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            )
        );
    };

    const handleViewData = (data, matNm) => {
        // console.log(data);
        setViewData(data);
        setFormData(prev => ({
            ...prev,
            matNm: matNm
        }));
    };

    const handleDeleteVewData = () => {
        setViewData([]);
        setFormData(prev => ({
            ...prev,
            matNm: ''
        }));
    };


    // console.log(material)
    return (
        <>
            <TitleBar data={Items} />
            <div style={{ margin: '1%' }}>
                <h2>Item - Material Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={1.2}>

                                {
                                    dropdownlistfirst && dropdownlistfirst?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {/* <Grid item xs={12} md={6}>

                                </Grid> */}

                                <RadioComponent
                                    label='Size Wise'
                                    name='sizewise'
                                    value={formData.sizewise}
                                    options={sizewiseoptions}
                                    isDesktop={isDesktop}
                                    onChange={handleRadioChange}
                                />



                                {formData.sizewise === "1" &&
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Size</TableCell>
                                                    {sizeWise?.map((item, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{item.size}</TableCell>
                                                    ))}
                                                </TableRow>


                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>{formData.matNm}</TableCell>
                                                    {sizeWise?.map((item, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center'>
                                                            <input
                                                                type="text"
                                                                value={item.matSize}
                                                                onChange={(e) =>
                                                                    handleSizeWiseChange(index, 'matSize', e.target.value)
                                                                }
                                                                style={{ width: '50px' }}
                                                            />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>


                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Qty</TableCell>
                                                    {sizeWise?.map((item, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center'>
                                                            <input
                                                                type="text"
                                                                value={item.qty}
                                                                onChange={(e) =>
                                                                    handleSizeWiseChange(index, 'qty', e.target.value)
                                                                }
                                                                style={{ width: '50px' }}
                                                            />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }


                                {viewData?.length > 0 &&

                                    <>

                                        <div style={{ position: 'absolute', top: '37vh', right: '2vw' }}>
                                            <CloseIcon className='cursor-pointer' onClick={handleDeleteVewData} />
                                        </div>

                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Size</TableCell>
                                                        {viewData?.map((item, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{item.size}</TableCell>
                                                        ))}
                                                    </TableRow>


                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>{formData.matNm}</TableCell>
                                                        {viewData?.map((item, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center'>
                                                                <input
                                                                    type="text"
                                                                    value={item.matSize}
                                                                    onChange={(e) =>
                                                                        handleSizeWiseChange(index, 'matSize', e.target.value)
                                                                    }
                                                                    style={{ width: '50px' }}
                                                                />
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>


                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Qty</TableCell>
                                                        {viewData?.map((item, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center'>
                                                                <input
                                                                    type="text"
                                                                    value={item.qty}
                                                                    onChange={(e) =>
                                                                        handleSizeWiseChange(index, 'qty', e.target.value)
                                                                    }
                                                                    style={{ width: '50px' }}
                                                                />
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </>
                                }

                                <div className="lump-content">
                                    {/* <h3>Material Entry </h3> */}
                                    <div className="button-group">
                                        <button className="add" onClick={handleAddlump}>Add</button>
                                        <button className="delete" onClick={handleRemoveLumps}>Remove</button>
                                    </div>
                                    <table style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>Material</th>
                                                {/* <th>Department</th> */}
                                                <th>View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {material?.map((mat, matIndex) => (
                                                <>
                                                    <tr key={matIndex}>
                                                        <td><input
                                                            type="checkbox"
                                                            checked={mat.selected}
                                                            onChange={() => handleLumpSelection(matIndex)}
                                                        />{" "}
                                                            {matIndex + 1}
                                                        </td>
                                                        <td>
                                                            {/* <input
                                                                type="text"
                                                                placeholder="material name"
                                                                value={mat.materialNm}
                                                                onChange={(e) => handleLumpColor(
                                                                    matIndex,
                                                                    e.target.value,
                                                                    "materialNm"
                                                                )}
                                                            /> */}
                                                            {mat.materialNm}
                                                        </td>
                                                        {/* <td>{mat.deptNm}</td> */}
                                                        {/* <td>
                                                            <input
                                                                type="text"
                                                                placeholder="qty"
                                                                value={mat.qty}
                                                                onChange={(e) => handleLumpColor(
                                                                    matIndex,
                                                                    e.target.value,
                                                                    "qty"
                                                                )}
                                                            />
                                                        </td> */}

                                                        <td><Preview onClick={() => handleViewData(mat.sizewise, mat.materialNm)} /></td>
                                                    </tr>
                                                </>
                                            ))}
                                            {/* <tr>
                                                <td> </td>
                                                <td> </td>
                                                <td>
                                                    <span className="tot-lump">Total Lump Mtr</span>
                                                </td>
                                                <td>
                                                    <span className="tot-lump">{lumpTotMtr}</span>
                                                </td>
                                            </tr> */}
                                        </tbody>
                                    </table>



                                </div>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ItemMaterial2;
